import PropTypes from "prop-types";
import React from "react";

import SVGIcon from "common/SVGIcon";
import { APPLICATION_STATE, PHONE_STATE } from "lib/constants";
import { applicationShape } from "lib/propTypes";

const CandidateUpdatePhoneReschedule = ({ application, phoneState }) => {
    const { position } = application;
    const canReschedule =
        application.state === APPLICATION_STATE.INTERVIEW && phoneState === PHONE_STATE.CHANGED;

    return (
        <div className="card-container">
            <div className="card card--feedback">
                {canReschedule && (
                    <div className="card__summary display-column">
                        <strong>{position.company_name}</strong>
                        <span>{position.title}</span>
                        <span>{position.city}</span>
                    </div>
                )}

                <div className="card__body card__body--success">
                    <SVGIcon icon="success-circle" />
                    <p>Phone number updated.</p>
                </div>
                {canReschedule && (
                    <div className="card__body">
                        <p className="text-center">
                            Would you like to reschedule your phone screen for this role?
                        </p>
                    </div>
                )}
            </div>

            <div className="card-container__footer">
                {canReschedule && (
                    <>
                        <a className="btn btn-primary btn-large" href={application.schedule_url}>
                            Yes, Reschedule
                        </a>
                        <a href={application.withdraw_url}>No, withdraw my application</a>
                    </>
                )}
                {!canReschedule && (
                    <a className="btn btn-primary btn-large" href="/">
                        Go Home
                    </a>
                )}
            </div>
        </div>
    );
};

CandidateUpdatePhoneReschedule.propTypes = {
    application: applicationShape.isRequired,
    phoneState: PropTypes.number.isRequired,
};

export default CandidateUpdatePhoneReschedule;
